import { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";

const useChatState = (selectDatasourse) => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [latestUserInput, setLatestUserInput] = useState("");
  const [latestBotResponseIndex, setLatestBotResponseIndex] = useState(null);
  const [sampleprompt, setSampleprompt] = useState(true);
  const [citationclickvisible, setCitationClickVisible] = useState(false);

  // Initialize session IDs
  const generateSessionId = () => uuidv4();

  let followsession_id = localStorage.getItem("followsession_id");
  let enrichsession_id = localStorage.getItem("enrichsession_id");
  let plan_generation_id = localStorage.getItem("plan_generation_id");
  let question_id = localStorage.getItem("question_id");

  if (!followsession_id || !enrichsession_id || !plan_generation_id || !question_id) {
    followsession_id = generateSessionId();
    enrichsession_id = generateSessionId();
    plan_generation_id = generateSessionId();
    question_id = generateSessionId();
    localStorage.setItem("followsession_id", followsession_id);
    localStorage.setItem("enrichsession_id", enrichsession_id);
    localStorage.setItem("plan_generation_id", plan_generation_id);
    localStorage.setItem("question_id", question_id);
  }

  // Initialize welcome messages
  useEffect(() => {
    setMessages((currentMessages) => {
      if (currentMessages.length > 0) {
        return currentMessages;
      }
      const userFullName = localStorage.getItem("userFullName") || "User";
      const systemMessage = {
        text: `Hello ${userFullName}! I'm your <b>AI Assistant Chatbot</b>. How can I help you today?`,
        isUser: false,
        isLoading: false,
        responseTime: 0,
        selectDatasourse: selectDatasourse,
        isSystemNotification: false,
      };

      const systemDatasourceMessage = {
        text: `Datasource selected - <b>Tastewise</b>`,
        isUser: false,
        isLoading: false,
        responseTime: 0,
        selectDatasourse: selectDatasourse,
        isSystemNotification: true,
        additional_agent_responses: {},
        reformatted_question: "",
      };

      return [systemMessage, systemDatasourceMessage];
    });
  }, [selectDatasourse]);

  return {
    messages,
    setMessages,
    input,
    setInput,
    isLoading,
    setIsLoading,
    latestUserInput,
    setLatestUserInput,
    latestBotResponseIndex,
    setLatestBotResponseIndex,
    sampleprompt,
    setSampleprompt,
    citationclickvisible,
    setCitationClickVisible,
    question_id,
    followsession_id,
    enrichsession_id,
    plan_generation_id,
  };
};

export default useChatState;
